import { gql } from '@apollo/client';

/**
 * One turn with the mutual fund research analyst: it reads the fund's data,
 * edits the note, records the reader's statements as assumptions, asks about
 * conflicts, and PROPOSES finalise — a CONFIRMATION_REQUIRED event carrying
 * `pendingActionId` and `confirmationToken`. Every turn ends with DONE.
 */
export const MF_ANALYST_CHAT = gql`
  subscription MfResearchAnalystChat($sessionId: Int!, $message: String!) {
    mfResearchAnalystChat(sessionId: $sessionId, message: $message) {
      type
      text
      toolName
      revisionId
      pendingActionId
      preview
      confirmationToken
      sessionId
      data
    }
  }
`;
